let data = {};
for (let i = 0; i < 100; i++) {
  data[i] = require("./data/template_"+i+".json");
}
export default data